module.exports = __webpack_public_path__ + "img/mobile-filter.1dc02d6.svg?v=1762502055057";